enum RegistrationStatus {
  CONFIRM = "CONFIRM",
  PENDING = "PENDING",
}

export default RegistrationStatus;
